import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { ValidierteXRechnung } from "../models/validierteXRechnung"

interface ValidierungBerichtViewProps {
    rechnung?: ValidierteXRechnung
}

export default function ValidierungBerichtView({ rechnung }: ValidierungBerichtViewProps) {
    const { t } = useTranslation()
    if (!rechnung) return null

    const parser = new DOMParser()
    const serializer = new XMLSerializer()

    const report = parser.parseFromString(rechnung.bericht, "text/xml")
    const htmlNode = report.querySelector("html")
    const htmlAsString = serializer.serializeToString(htmlNode as Node)
    const htmlDataUrl = URL.createObjectURL(new Blob([htmlAsString], { type: "text/xml" }))

    return (
        <div className={`alert alert-${rechnung.validierungErfolgreich ? "success" : "danger"}`} role="alert">
            <span key="1">
                {rechnung.validierungErfolgreich && (
                    <Trans t={t} i18nKey="validierung.bericht.messageEins.success" values={{ rechnungFormat: rechnung.format }} />
                )}
                {!rechnung.validierungErfolgreich && (
                    <Trans t={t} i18nKey="validierung.bericht.messageEins.error" values={{ rechnungFormat: rechnung.format }} />
                )}
            </span>
            <hr />
            <span key="2">
                {t("validierung.bericht.messageZwei")}
                <span> </span>
                <a href={htmlDataUrl} target="_blank" rel="noopener noreferrer">
                    {t("validierung.bericht.messageDrei")}
                </a>
            </span>
        </div>
    )
}
